<!--
  --
  -- 許諾事項 ページ
  --
  -->
<template>
  <c-container form>
    <!-- フォーム -->
    <v-card>
      <v-card-title>{{agreements.title}}</v-card-title>

      <v-card-text>

        <!-- 同意事項の参照 -->
        <p>
          <span v-html="agreements.text1"></span>
          <span
            v-for="(item, index) in agreements.links"
            :key="index"
          >
            <template v-if="index > 0">、</template>
            <a :href="item.url" target="_blank">{{item.name}}</a>
          </span>
          <span v-html="agreements.text2"></span>
        </p>

        <!-- 同意事項の説明 -->
        <p>
          <span v-html="agreements.text3"></span>

          <span
            v-for="(item, index) in agreements.links"
            :key="index"
          >
            <template v-if="index > 0">、</template>
            <template>「{{item.name}}」</template>
          </span>

          <span v-html="agreements.text4"></span>
        </p>

        <!-- 外国人の取り扱い -->
        <p>
          <span v-if="foreignFlg === 1">
            尚、ご利用は有効な日本の免許証が必要となります<br />
            Valid Japanese Driver's License required.
          </span>
        </p>

        <c-agree-group
          :agreements="agreements"
          :form="form"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary" :disabled="!agreed"
          @click="onNext"
          v-text="'次へ'"
        />
      </v-card-actions>
    </v-card>

    <!-- タイムアウト制御 -->
    <c-timeout/>
  </c-container>
</template>

<script>
import page from '@/mixins/page'
import CAgreeGroup from './CAgreeGroup'
import CTimeout from '../CTimeout'

export default {
  name: 'Agree',
  mixins: [
    page('許諾事項')
  ],
  components: {
    CAgreeGroup,
    CTimeout
  },
  data: () => ({
    form: {
      agrees: []
    }
  }),
  computed: {
    /**
     * 許諾事項
     */
    agreements () {
      return this.getters['org/agreements']
    },

    /**
     * すべての許諾事項に同意したか
     */
    agreed () {
      return this.form.agrees.length === this.agreements.links.length
    },

    /**
     * 外国人の取り扱い
     */
    foreignFlg (store) {
      return store.getters['org/foreignFlg']
    }
  },
  created () {
    // チェックボックスの選択内容を作成
    // 例) 2つの許諾事項があれば [0, 1] を作成する
    if (this.getters['register/agreed']) {
      this.form.agrees = range(0, this.agreements.links.length)
    }
  },
  methods: {
    /**
     * 次へを押された
     */
    onNext () {
      // store に許諾同意を保存する
      this.commit('register/setAgreed', true)

      // 次のページへ
      this.goTo({ name: 'register/email' })
    }
  }
}

/**
 * 指定した連番の配列を返す
 *
 * @param {Number} first 開始番号
 * @param {Number} last 終了番号。この番号は返される連番には含まれない。
 * @returns {Array} 連番の配列を返す
 */
function range (first, last) {
  const len = Math.max(last - first, 0)
  const v = new Array(len)
  for (let i = 0; i < len; ++i) {
    v[i] = first + i
  }
  return v
}
</script>
